
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[...slugs]",
      function () {
        return require("private-next-pages/[...slugs]/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/[...slugs]"])
      });
    }
  